import { render, staticRenderFns } from "./PublicHolidays.vue?vue&type=template&id=18232fb2&scoped=true"
import script from "./PublicHolidays.vue?vue&type=script&lang=js"
export * from "./PublicHolidays.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidays.vue?vue&type=style&index=0&id=18232fb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18232fb2",
  null
  
)

export default component.exports